import { usePermissions } from '../providers';

export function useCurrentUser() {
  const { user, isLoading, error } = usePermissions();
  return { user, isLoading, error };
}
